// @ts-nocheck
(function () {
  function getActiveHeading(section) {
    const isMobile = window.matchMedia('(max-width: 991px)').matches;
    return section.querySelector(isMobile ? '.mobile_heading' : '.desktop_heading');
  }

  function getFillVariantClass(fill) {
    if (!fill) return 'FactoryStorySection__charFill--green';

    return Array.from(fill.classList).reduce((variantClass, className) => {
      if (variantClass) return variantClass;

      if (className === 'FactoryStorySection__segmentFill--dark') {
        return 'FactoryStorySection__charFill--dark';
      }

      if (className === 'FactoryStorySection__segmentFill--green') {
        return 'FactoryStorySection__charFill--green';
      }

      return variantClass;
    }, '');
  }

  function buildSegmentContent(text, fillVariantClass) {
    const fragment = document.createDocumentFragment();
    const words = text.split(' ');

    words.forEach((word, wordIndex) => {
      if (wordIndex > 0) {
        fragment.appendChild(document.createTextNode(' '));
      }

      const wordNode = document.createElement('span');
      wordNode.className = 'FactoryStorySection__word';

      Array.from(word).forEach((character) => {
        const charNode = document.createElement('span');
        charNode.className = 'FactoryStorySection__char';
        const baseNode = document.createElement('span');
        const fillNode = document.createElement('span');

        baseNode.className = 'FactoryStorySection__charBase';
        baseNode.textContent = character;

        fillNode.className = 'FactoryStorySection__charFill';
        if (fillVariantClass) {
          fillNode.classList.add(fillVariantClass);
        }
        fillNode.textContent = character;
        fillNode.setAttribute('data-segment-char', '');

        charNode.appendChild(baseNode);
        charNode.appendChild(fillNode);
        wordNode.appendChild(charNode);
      });

      fragment.appendChild(wordNode);
    });

    return fragment;
  }

  function prepareSegment(segment) {
    if (!segment || segment.dataset.segmentPrepared === 'true') return;

    const base = segment.querySelector('.FactoryStorySection__segmentBase');
    const fill = segment.querySelector('[data-segment-fill]');

    if (!base || !fill) return;

    const text = base.textContent || fill.textContent || '';
    const fillVariantClass = getFillVariantClass(fill);

    segment.textContent = '';
    segment.appendChild(buildSegmentContent(text, fillVariantClass));

    segment.dataset.segmentPrepared = 'true';
  }

  function setFinalState(section) {
    section.querySelectorAll('[data-story-segment]').forEach((segment) => {
      segment.style.opacity = '1';
    });

    section.querySelectorAll('[data-segment-char]').forEach((char) => {
      char.style.opacity = '1';
    });

    section.querySelectorAll('[data-story-card]').forEach((card) => {
      card.style.opacity = '1';
      card.style.filter = 'blur(0px)';
      card.style.transform = '';
    });

    section.querySelectorAll('.FactoryStorySection__button').forEach((button) => {
      button.style.opacity = '1';
      button.style.transform = '';
    });
  }

  function initStorySection(section) {
    if (!window.gsap || !window.ScrollTrigger) {
      setFinalState(section);
      return;
    }

    if (section.dataset.storyReady === 'true') return;
    section.dataset.storyReady = 'true';

    gsap.registerPlugin(ScrollTrigger);

    const pinTarget = section.querySelector('[data-story-pin]');
    const activeHeading = getActiveHeading(section);
    const button = section.querySelector('.FactoryStorySection__button');
    const segments = activeHeading
      ? gsap.utils.toArray(activeHeading.querySelectorAll('[data-story-segment]'))
      : [];
    const cards = gsap.utils.toArray(section.querySelectorAll('[data-story-card]'));

    segments.forEach(prepareSegment);

    const fillChars = segments.map((segment) => gsap.utils.toArray(segment.querySelectorAll('[data-segment-char]')));

    if (!pinTarget || segments.length !== 4 || fillChars.length !== 4 || cards.length !== 4) {
      setFinalState(section);
      return;
    }

    const mm = gsap.matchMedia();

    mm.add('(prefers-reduced-motion: reduce)', () => {
      setFinalState(section);
    });

    mm.add('(prefers-reduced-motion: no-preference)', () => {
      gsap.set(segments, { opacity: 1 });
      fillChars.forEach((chars) => {
        gsap.set(chars, { opacity: 0 });
      });

      cards.forEach((card) => {
        gsap.set(card, {
          opacity: 0,
          scale: 0.5,
          filter: 'blur(10px)',
          transformOrigin: 'center center'
        });
      });

      if (button) {
        gsap.set(button, {
          opacity: 0,
          y: 24
        });
      }

      const tl = gsap.timeline({
        defaults: {
          ease: 'none'
        },
        scrollTrigger: {
          trigger: section,
          start: 'top top',
          end: '+=3600',
          scrub: 0.8,
          pin: pinTarget,
          anticipatePin: 1,
          invalidateOnRefresh: true
        }
      });

      tl.to({}, { duration: 0.12 })
        .addLabel('stage1')
        .set(segments[0], { opacity: 1 }, 'stage1')
        .to(fillChars[0], { opacity: 1, duration: 0.04, stagger: 0.04 }, 'stage1')
        .to(cards[0], { opacity: 1, scale: 1, filter: 'blur(0px)', duration: 1 }, 'stage1')
        .addLabel('stage2')
        .set(segments[1], { opacity: 1 }, 'stage2')
        .to(fillChars[1], { opacity: 1, duration: 0.04, stagger: 0.04 }, 'stage2')
        .to(cards[1], { opacity: 1, scale: 1, filter: 'blur(0px)', duration: 1 }, 'stage2')
        .addLabel('stage3')
        .set(segments[2], { opacity: 1 }, 'stage3')
        .to(fillChars[2], { opacity: 1, duration: 0.04, stagger: 0.04 }, 'stage3')
        .to(cards[2], { opacity: 1, scale: 1, filter: 'blur(0px)', duration: 1 }, 'stage3')
        .addLabel('stage4')
        .set(segments[3], { opacity: 1 }, 'stage4')
        .to(fillChars[3], { opacity: 1, duration: 0.04, stagger: 0.04 }, 'stage4')
        .to(cards[3], { opacity: 1, duration: 0.2 }, 'stage4')
        .to(cards[3], { scale: 1, filter: 'blur(0px)', duration: 1.4 }, 'stage4+=0.22');

      if (button) {
        tl.to(button, { opacity: 1, y: 0, duration: 0.7 }, 'stage4+=1.62');
      }

      return () => {
        tl.scrollTrigger && tl.scrollTrigger.kill();
        tl.kill();
      };
    });
  }

  function bootStorySections() {
    document.querySelectorAll('[data-story-section]').forEach(initStorySection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootStorySections);
  } else {
    bootStorySections();
  }
})();
